export default __webpack_public_path__ + "static/media/editprofile.99a9b975.svg";